module.exports = __webpack_public_path__ + "static/analytics-min-975e2460fd2e5f6647bfef2254694da0.png";